import React, { useState } from "react";
import { submitClassChangeRequest } from "../../service.js";
import { toast } from "react-toastify";
import Toast from "../../components/Toast";
import { Overlay, Modal, Header, Title, CloseBtn, Form, Label, Textarea, SubmitBtn } from "./styles.js";


// Class Change Request Modal Component
export default function ClassChangeRequestModal({ onClose, onSubmit }) {

    const [formData, setFormData] = useState({
        requestedChanges: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const limits = {
            requestedChanges: 2000
        };

        const fieldLabels = {
            requestedChanges: "requested changes"
        };

        for (const [key, value] of Object.entries(formData)) {
            if (!value || !value.trim()) {
                toast(<Toast message={`Failed to submit request as ${fieldLabels[key]} is empty. Please try again`} />);
                return;
            }
            if (value.length > limits[key]) {
                toast(<Toast message={`Failed to submit request as character limit for ${fieldLabels[key]} has exceeded. Please try again.`} />);
                return;
            }
        }

        try {
            const response = await submitClassChangeRequest(formData);
            if (response && response.errorMessage) {
                // modifyData already shows the error toast, so we just stop here
                return;
            }
            toast(<Toast message={'Request submitted successfully!'} />);
            if (onSubmit) onSubmit();
            if (onClose) onClose();
        } catch (error) {
            toast(<Toast message={'Failed to send request. Please try again.'} />);
        }
    };

    return (
        <Overlay>
            <Modal>
                <Header>
                    <Title>Class change request</Title>
                    <CloseBtn onClick={onClose}>✕</CloseBtn>
                </Header>

                <Form onSubmit={handleSubmit}>

                    <Label>
                        List of requested changes
                        <Textarea
                            name="requestedChanges"
                            placeholder="Inc. full student names AND class codes of old and new classes"
                            rows={4}
                            value={formData.requestedChanges}
                            onChange={handleChange}
                        />
                    </Label>

                    <SubmitBtn type="submit">
                        Submit
                    </SubmitBtn>

                </Form>
            </Modal>
        </Overlay>
    );
}